(function () {
  // ==========================================================================
  // auto-checkout-protection.js  —  v2.4.2  (Bourbon Group)   STORE: RARE
  // --------------------------------------------------------------------------
  // v2.4 (2026-06-23) — DECLINE GUARDRAIL (emergency fix):
  //   PROBLEM: reconcile() auto-adds protection on add-to-cart / cart-change.
  //   The opt-out flag (sessionStorage 'tb_protection_optout') was set ONLY when
  //   the shopper clicked the visible toggle OFF. A shopper who instead REMOVED
  //   the protection line directly (the cart's trash icon / quantity -> 0) left
  //   the flag unset, so the very next add-to-cart silently RE-INJECTED
  //   protection — it felt like the option was being forced back on.
  //
  //   FIX: treat "remove the protection line" EXACTLY like "switch the toggle
  //   OFF" — both are a decline. Once declined, reconcile() leaves protection
  //   out and does NOT re-add it on subsequent add-to-cart actions. The visible
  //   toggle stays on the page the whole time, so the shopper can turn
  //   protection back ON (setOptedOut(false) -> reconcile re-adds at the correct
  //   band) whenever they like. Nothing is ever forced.
  //
  //   The decline is detected in THREE layers, earliest first:
  //     (1) capture-phase CLICK on the protection line's remove control — sets
  //         the flag at click time (synchronous sessionStorage write that even
  //         survives a full-page-nav remove), before the theme issues any cart
  //         write. This is the PRIMARY, identity-stable signal: it matches the
  //         protection row by its exact /products/<handle> link (not a line
  //         index), so a band-swap reordering the cart can't fool it.
  //     (2) synchronous REQUEST inspection — catches an AJAX /cart/update|change
  //         that zeroes the protection line by STABLE identity (variant id / line
  //         key only; see v2.4.1 note re: line ordinals).
  //     (3) presence-diff BACKSTOP after the write settles — catches anything
  //         (1) and (2) missed, while explicitly ignoring reconcile's own
  //         in-flight band-swap window.
  //   All three set the SAME flag the toggle uses and dispatch
  //   'tb:protection:changed' so the toggle visibly flips to OFF. Our OWN cart
  //   writes carry X-TB-Protection and are skipped, so band-swaps / cleanup
  //   removals never count as a decline.
  //
  // v2.4.1 (2026-06-23, post adversarial review) — fix two false-OPT-OUT bugs
  //   that would have SUPPRESSED protection on legitimate (non-decline) flows:
  //     (a) Layer 2 no longer matches a cart write by its numeric `line` ordinal
  //         (or array index). reconcile()'s remove-then-add band-swap reorders
  //         the cart, so a cached line index goes stale and could collide with a
  //         BOTTLE the shopper removes -> false decline. We now match only on
  //         stable variant id / line key. The trash gesture is covered race-free
  //         by Layer 1 (DOM identity); the qty-stepper residue by Layer 3.
  //     (b) onUserCartChange() now bails while reconcile() is in-flight, and
  //         lastProtectionPresent is updated only AFTER a reconcile pass settles
  //         (to the state we drove the cart to) — so the brief protection-absent
  //         window during a band-swap is never misread as a decline.
  //   Also: Layer-1 handle match is now EXACT (avoids matching e.g.
  //   shipping-protection-40 against shipping-protection-4), and refs are seeded
  //   from the server-rendered cart DOM at init.
  //
  //   Only PROTECTION_PRODUCT_HANDLE differs per store (Total =
  //   shipping-protection-4 | Top = shipping-protection-1 | Rare =
  //   shipping-protection-3). Byte-identical across stores except that handle +
  //   the STORE label above.
  //
  // --- prior history (unchanged behavior) -----------------------------------
  //   v2  (2026-06-22, "option one"): auto-add moved from checkout-click to
  //   add-to-cart / cart-change / page-load via an idempotent reconcile(), so
  //   protection is a real cart line item BEFORE any express/accelerated button
  //   (Apple Pay, Google Pay, Shop Pay, "Buy it now") on the cart page/drawer.
  //   Band-matching ('0T150'..'10000TN', subtotal excludes protection) + gift-
  //   card / empty-cart exclusion unchanged. Standard checkout-button intercept
  //   kept as a final safety net. (Does NOT cover a PDP dynamic-checkout that
  //   skips the cart entirely — separate "move #2", not in scope.)
  //   v2.1: fire theme-native 'dispatch:cart-drawer:refresh' on a trailing delay
  //   so the line stays visible after product-form.js's ~700ms re-render.
  //   v2.2: deterministic add path — patch the /cart/add response sections with
  //   freshly-rendered ones that already include protection (no flash/clobber).
  //   v2.3: gift cards no longer inflate the protected subtotal; XHR cart-write
  //   hook removed (loop seed; theme uses fetch).
  // ==========================================================================
  if (window.__tbProtectionV2) return;
  window.__tbProtectionV2 = true;

  var PROTECTION_PRODUCT_HANDLE = 'shipping-protection-3';
  var CHECKOUT_PATH = '/checkout';
  var OPTOUT_KEY = 'tb_protection_optout';
  var SELF_HEADER = 'X-TB-Protection';

  var protectionProductPromise = null;
  var reconciling = false;
  var reconcileQueued = false;
  var debounceTimer = null;
  var reconcileActive = null;

  // --- decline-guardrail state (v2.4) ---------------------------------------
  // lastProtectionPresent: the protection line's presence as of the last SETTLED
  //   reconcile pass (updated only after a pass completes — see reconcile()).
  //   The presence-diff backstop compares the next user write against it.
  // protectionLineRefs: STABLE identity (variant_id / line key) of the live
  //   protection line(s), so the synchronous request matcher can recognize a
  //   write that zeroes it. NOTE: no line ordinal is stored — it isn't stable
  //   across band-swaps (v2.4.1).
  var lastProtectionPresent = false;
  var protectionLineRefs = [];

  function isOptedOut() {
    try { return sessionStorage.getItem(OPTOUT_KEY) === '1'; } catch (e) { return false; }
  }
  function persistOptOut(v) {
    try { sessionStorage.setItem(OPTOUT_KEY, v ? '1' : '0'); } catch (e) {}
  }
  // Record a decline once: persist the flag, drop the cached presence, and tell
  // the visible toggle to show OFF. Idempotent (no-op if already opted out).
  function markDeclined() {
    if (isOptedOut()) return;
    persistOptOut(true);
    lastProtectionPresent = false;
    try { document.dispatchEvent(new CustomEvent('tb:protection:changed', { detail: { optedOut: true } })); } catch (e) {}
  }

  function jsonGet(url) {
    return fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('GET failed: ' + url); return r.json(); });
  }

  function jsonPost(url, body) {
    // Marked self-request so our own cart writes don't re-trigger reconcile()
    // OR get mistaken for a shopper decline.
    var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    headers[SELF_HEADER] = '1';
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: headers, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('POST failed: ' + url); return r.json(); });
  }

  function getProtectionProduct() {
    if (!protectionProductPromise) {
      protectionProductPromise = jsonGet('/products/' + PROTECTION_PRODUCT_HANDLE + '.js')
        .catch(function (e) { protectionProductPromise = null; throw e; });
    }
    return protectionProductPromise;
  }

  function parseVariantBand(variant) {
    var match = /^(\d+)T(\d+|N)$/.exec((variant.title || '').trim());
    if (!match) return null;
    return {
      variant: variant,
      minCents: Number(match[1]) * 100,
      maxCents: match[2] === 'N' ? Infinity : Number(match[2]) * 100
    };
  }

  function selectProtectionVariant(product, subtotalCents) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var bands = variants.map(parseVariantBand).filter(Boolean).sort(function (a, b) { return a.minCents - b.minCents; });
    if (bands.length) {
      // Exact band, else the next band up (covers gaps and the open-ended top
      // band), else the highest band.
      var matched = bands.find(function (b) { return subtotalCents >= b.minCents && subtotalCents < b.maxCents; }) ||
        bands.find(function (b) { return subtotalCents < b.maxCents; }) ||
        bands[bands.length - 1];
      if (matched.variant.available) return matched.variant;
      var index = bands.indexOf(matched);
      for (var i = index + 1; i < bands.length; i++) { if (bands[i].variant.available) return bands[i].variant; }
      for (var j = index - 1; j >= 0; j--) { if (bands[j].variant.available) return bands[j].variant; }
    }
    return variants.find(function (v) { return v.available; }) || variants[0] || null;
  }

  function getCart() { return jsonGet('/cart.js'); }

  function isProtectionItem(item) {
    return item.handle === PROTECTION_PRODUCT_HANDLE || item.url === ('/products/' + PROTECTION_PRODUCT_HANDLE);
  }
  function isGiftCard(item) { return (item.product_type || '').toLowerCase() === 'gift card'; }

  // Refresh the cached protection-line references from a cart we just read.
  // STABLE identity only (variant id + line key); no line ordinal (v2.4.1).
  function recordProtectionLineRefs(cart, protectionItems) {
    protectionLineRefs = (protectionItems || []).map(function (i) {
      return { variant_id: i.variant_id, key: i.key };
    });
  }

  function protectableSubtotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    // Exclude protection AND gift cards — gift cards aren't shippable goods, so
    // counting them would over-band (over-charge) protection on mixed carts.
    return cart.items.filter(function (i) { return !isProtectionItem(i) && !isGiftCard(i); })
      .reduce(function (s, i) {
        var lp = typeof i.final_line_price === 'number' ? i.final_line_price : i.line_price;
        return s + (lp || 0);
      }, 0);
  }

  function eligibleForProtection(cart) {
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) return false;
    var nonProt = cart.items.filter(function (i) { return !isProtectionItem(i); });
    if (!nonProt.length) return false;
    if (nonProt.every(isGiftCard)) return false;          // gift-card-only cart
    if (protectableSubtotal(cart) <= 0) return false;       // $0 / fully-discounted
    return true;
  }

  function addVariant(variantId) {
    return jsonPost('/cart/add.js', { items: [{ id: variantId, quantity: 1, properties: { '_auto_added': 'true' } }] });
  }

  function removeProtection(protectionItems) {
    var updates = {};
    protectionItems.forEach(function (i) { var k = (i.key != null) ? i.key : i.variant_id; if (k != null) updates[k] = 0; });
    if (!Object.keys(updates).length) return Promise.resolve(null);
    return jsonPost('/cart/update.js', { updates: updates });
  }

  function themeRefresh() {
    // Enterprise E.1 (Dawn-family) re-renders the cart drawer + items from the
    // CURRENT server cart on this event:
    //   cart-drawer.js -> document.addEventListener('dispatch:cart-drawer:refresh', ...)
    //   -> CartDrawer.refresh() -> cart-items.refresh() -> GET ?sections=... -> re-render
    // This makes the auto-added protection line visible AFTER the theme's own
    // (stale, pre-protection) render. Triggers schedule it on a trailing delay
    // so it lands AFTER product-form.js's 700ms setTimeout renderContents().
    try { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true })); } catch (e) {}
    // v2.4.3 (2026-06-29) - cart PAGE refresh. The cart page has no #cart-drawer
    // element and its <cart-items> does NOT listen for the event above; it
    // re-renders only via its own refresh() (GET ?sections = CURRENT server cart).
    // Without this, after our self-issued /cart/update.js the cart page shows a
    // STALE cart (a toggled-off protection line lingers) until a manual reload.
    // Refresh any cart-items NOT inside the drawer (the cart-page instance); the
    // drawer is handled by the event above, so this is a no-op on non-cart pages.
    try {
      document.querySelectorAll('cart-items').forEach(function (el) {
        if (el.closest && el.closest('#cart-drawer')) return;
        if (typeof el.refresh === 'function') el.refresh();
      });
    } catch (e) {}
  }

  // Core: bring the cart to exactly the right protection state in one pass.
  // Idempotent — does nothing when the cart is already correct, so it is safe to
  // call from many triggers. Honors the decline flag (isOptedOut) so a shopper
  // who removed protection / toggled it off is never re-charged.
  function reconcile() {
    if (reconciling) { reconcileQueued = true; return reconcileActive || Promise.resolve(); }
    reconciling = true;
    var desiredPresent = lastProtectionPresent;  // updated to the settled state below
    reconcileActive = getCart().then(function (cart) {
      var protectionItems = (cart.items || []).filter(isProtectionItem);
      recordProtectionLineRefs(cart, protectionItems);
      var shouldHave = eligibleForProtection(cart) && !isOptedOut();
      desiredPresent = shouldHave;

      if (!shouldHave) {
        if (protectionItems.length) return removeProtection(protectionItems).then(function () { return true; });
        return false;
      }
      return getProtectionProduct().then(function (product) {
        var desired = selectProtectionVariant(product, protectableSubtotal(cart));
        if (!desired || !desired.id) return false;
        var correct = protectionItems.length === 1 &&
          protectionItems[0].variant_id === desired.id &&
          protectionItems[0].quantity === 1;
        if (correct) return false;
        return removeProtection(protectionItems)
          .then(function () { return addVariant(desired.id); })
          .then(function () { return true; });
      });
    })
      .then(function (mutated) {
        // Update the cached presence ONLY after the pass settles, to the state we
        // just drove the cart to. Setting it mid-pass (before the remove->add
        // resolved) previously let onUserCartChange misread the brief
        // protection-absent window of a band-swap as a decline (v2.4.1).
        lastProtectionPresent = desiredPresent;
        if (mutated) setTimeout(themeRefresh, 300);
      })
      .catch(function (err) { console.error('Auto checkout protection reconcile error:', err); })
      .finally(function () {
        reconciling = false;
        reconcileActive = null;
        if (reconcileQueued) { reconcileQueued = false; reconcile(); }
      });
    return reconcileActive;
  }

  function scheduleReconcile() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { debounceTimer = null; reconcile(); }, 150);
  }

  // ---- Decline detection helpers (v2.4 / v2.4.1) ---------------------------
  // True iff this DOM row is the protection line. EXACT handle match (a
  // /products/<handle> link whose path equals the handle exactly), falling back
  // to a known protection variant id. Reorder-stable (no line index).
  function rowIsProtection(row) {
    if (!row || !row.querySelectorAll) return false;
    var links = row.querySelectorAll('a[href*="/products/"]');
    var marker = '/products/' + PROTECTION_PRODUCT_HANDLE;
    for (var i = 0; i < links.length; i++) {
      var path = (links[i].getAttribute('href') || '').split('?')[0].replace(/\/+$/, '');
      var at = path.indexOf('/products/');
      if (at > -1 && path.substring(at) === marker) return true;
    }
    var vid = row.getAttribute && row.getAttribute('data-variant-id');
    if (vid && protectionLineRefs.some(function (r) { return String(r.variant_id) === String(vid); })) return true;
    return false;
  }

  // Seed refs from the server-rendered cart DOM so Layer 2 / byVariant work in
  // the brief window before the first /cart.js read resolves.
  function seedRefsFromDom() {
    try {
      if (protectionLineRefs.length) return;
      var rows = document.querySelectorAll('.cart-item[data-variant-id], tr[data-variant-id]');
      var refs = [];
      for (var i = 0; i < rows.length; i++) {
        if (rowIsProtection(rows[i])) {
          var vid = rows[i].getAttribute('data-variant-id');
          if (vid) refs.push({ variant_id: Number(vid), key: null });
        }
      }
      if (refs.length) protectionLineRefs = refs;
    } catch (e) {}
  }

  // Parse a cart-write's params from the URL query OR the request body, covering
  // the forms the theme uses: /cart/change?id=&quantity=,  JSON/Form bodies
  // { id|line, quantity },  and /cart/update { updates: {key: qty} }.
  function parseCartWriteParams(url, init) {
    var out = null;
    try {
      var qIndex = url.indexOf('?');
      if (qIndex > -1) {
        var sp = new URLSearchParams(url.slice(qIndex + 1));
        if (sp.has('quantity') && (sp.has('id') || sp.has('line'))) {
          out = { quantity: Number(sp.get('quantity')), id: sp.get('id'), line: sp.get('line') };
        }
      }
    } catch (e) {}
    try {
      var body = init && init.body;
      if (body) {
        if (typeof body === 'string') {
          var d = JSON.parse(body);
          if (d && typeof d === 'object') out = d;
        } else if (typeof body.forEach === 'function') { // FormData / URLSearchParams
          var o = {}; body.forEach(function (v, k) { o[k] = v; });
          if (Object.keys(o).length) out = o;
        }
      }
    } catch (e) {}
    return out;
  }

  // Does this non-self cart write zero out the protection line, by STABLE
  // identity (variant id / line key)? Best-effort and synchronous, so we can
  // record the decline BEFORE any reconcile re-adds.
  // v2.4.1: deliberately does NOT match on the numeric `line` ordinal (nor the
  // positional array form) — line indices are not stable across reconcile
  // band-swaps and the theme's /cart/change for a trash/qty removal carries only
  // `line`, so matching it produced a false opt-out when a shopper removed a
  // BOTTLE whose post-swap line collided with a stale cached protection line.
  // The trash gesture is instead caught race-free by Layer 1 (DOM identity), and
  // the qty-stepper residue by the Layer-3 presence-diff backstop.
  function requestRemovesProtection(url, init) {
    if (!protectionLineRefs.length) return false;
    var d = parseCartWriteParams(url, init);
    if (!d) return false;
    function matchesRef(key) {
      var k = String(key);
      return protectionLineRefs.some(function (r) {
        return k === String(r.variant_id) || (r.key != null && k === String(r.key));
      });
    }
    // /cart/update with a MAP { <id|key>: qty } -> qty 0 on our id/key.
    if (d.updates && typeof d.updates === 'object' && !Array.isArray(d.updates)) {
      return Object.keys(d.updates).some(function (k) { return Number(d.updates[k]) === 0 && matchesRef(k); });
    }
    // /cart/change { id, quantity } -> quantity 0 on our variant id (stable).
    if (typeof d.quantity !== 'undefined' && Number(d.quantity) === 0) {
      if (d.id != null && matchesRef(d.id)) return true;
    }
    return false;
  }

  // Layer 3 — presence-diff backstop. Runs after a non-self change/update/clear
  // settles. If protection WAS present and is now gone while the cart is still
  // eligible (and we haven't already recorded the decline), treat it as a
  // decline; otherwise reconcile normally.
  function onUserCartChange() {
    // Don't classify a decline while reconcile() is mid-flight: its non-atomic
    // band-swap (remove then add) briefly shows protection ABSENT server-side,
    // which is NOT a shopper decline. Defer; the settled state decides. A
    // genuine trash removal is already captured synchronously by Layer 1.
    if (reconciling) { scheduleReconcile(); return Promise.resolve(); }
    return getCart().then(function (cart) {
      var protNow = (cart.items || []).filter(isProtectionItem);
      recordProtectionLineRefs(cart, protNow);
      var hasProtection = protNow.length > 0;
      var declined = lastProtectionPresent && !hasProtection &&
        eligibleForProtection(cart) && !isOptedOut();
      lastProtectionPresent = hasProtection;
      if (declined) {
        markDeclined();
        setTimeout(themeRefresh, 700);  // repaint toggle (now OFF) + cart
        return;                          // honor the decline — do NOT reconcile/re-add
      }
      scheduleReconcile();               // any other edit: normal reconcile
      setTimeout(themeRefresh, 700);
    }).catch(function () { scheduleReconcile(); });
  }

  // ---- Triggers ------------------------------------------------------------
  // 1) Intercept storefront cart writes (theme add/change/update/clear) and
  //    reconcile once the theme's own request settles. Our writes carry
  //    SELF_HEADER and are skipped to avoid recursion; reconcile() is idempotent
  //    so any extra trigger is a harmless no-op.
  var cartWriteRe = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var cartAddRe = /\/cart\/add(\.js)?(\?|$)/;
  var origFetch = null;

  function headerHasSelf(headers) {
    if (!headers) return false;
    try {
      if (typeof headers.get === 'function') return headers.get(SELF_HEADER) != null;
      return headers[SELF_HEADER] === '1' || headers[SELF_HEADER.toLowerCase()] === '1';
    } catch (e) { return false; }
  }

  // DETERMINISTIC add path: wait for the theme's /cart/add, ensure protection is
  // in the cart, then return a replacement response whose cart SECTIONS are
  // freshly rendered (so they already include protection). product-form.js then
  // renders the protection line on its first paint — no 700ms flash/clobber.
  // Any failure falls back to the original response + a trailing refresh (v2.1).
  function patchAddResponse(resp, init) {
    if (!resp || !resp.ok || typeof Response === 'undefined') { setTimeout(themeRefresh, 1000); return resp; }
    var secNames = null, secUrl = null;
    try {
      if (init && init.body && typeof init.body.get === 'function') {
        var sv = init.body.get('sections'); if (sv) secNames = String(sv);
        var su = init.body.get('sections_url'); if (su) secUrl = String(su);
      }
    } catch (e) {}
    return resp.clone().json().then(function (data) {
      return reconcile().then(function () {
        if (!secNames || !data || !data.sections) { setTimeout(themeRefresh, 1000); return resp; }
        var u = secUrl || window.location.pathname;
        u += (u.indexOf('?') === -1 ? '?' : '&') + 'sections=' + encodeURIComponent(secNames);
        return origFetch(u, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (fresh) {
            if (fresh && typeof fresh === 'object') {
              Object.keys(fresh).forEach(function (k) { data.sections[k] = fresh[k]; });
            }
            return new Response(JSON.stringify(data), {
              status: resp.status, statusText: resp.statusText, headers: { 'Content-Type': 'application/json' }
            });
          })
          .catch(function () { setTimeout(themeRefresh, 1000); return resp; });
      });
    }).catch(function () { setTimeout(themeRefresh, 1000); return resp; });
  }

  if (window.fetch && !window.fetch.__tbWrapped) {
    origFetch = window.fetch;
    var wrapped = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var isSelf = init && headerHasSelf(init.headers);
      // Layer 2 (v2.4): record a decline synchronously, BEFORE the request goes
      // out, if a NON-self cart write zeroes the protection line by stable id.
      if (!isSelf && cartWriteRe.test(url) && !cartAddRe.test(url) && requestRemovesProtection(url, init)) {
        markDeclined();
      }
      var p = origFetch.apply(this, arguments);
      if (isSelf) return p;
      if (cartAddRe.test(url)) {
        // gate + patch so the theme paints protection on its first render
        return p.then(function (resp) { return patchAddResponse(resp, init); });
      }
      if (cartWriteRe.test(url)) {
        // change/update/clear: decline-aware reconcile + display refresh
        p.then(function () { onUserCartChange(); }).catch(function () {});
      }
      return p;
    };
    wrapped.__tbWrapped = true;
    window.fetch = wrapped;
  }

  // (v2.3) XMLHttpRequest cart-write hook intentionally REMOVED. This theme issues
  // all cart writes via fetch (covered above). The XHR hook could not carry our
  // SELF_HEADER, so a first/third-party cart write via XHR would re-trigger
  // reconcile with no self-guard — a latent oscillation/loop seed. fetch + the
  // theme cart events + the on-load reconcile cover every real path.

  // Layer 1 (v2.4) — earliest, race-free decline signal. A click on the
  // protection line's own remove control is an explicit decline. Capture phase
  // so the flag is set BEFORE the theme issues its cart write or dispatches its
  // cart events (whose handlers would otherwise reconcile -> re-add), and BEFORE
  // a full-page-nav remove unloads (sessionStorage write is synchronous).
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var removeEl = t.closest('a.cart-item__remove, .js-remove-item, cart-remove-button, [data-cart-remove]');
    if (!removeEl) return;
    var row = removeEl.closest('.cart-item, tr[data-variant-id], [data-variant-id]');
    if (rowIsProtection(row)) markDeclined();
  }, true);

  // 2) Theme-native cart signals (Enterprise E.1 dispatches these from
  //    product-form.js / cart-items.js) + generic fallbacks + section reloads.
  ['on:cart:add', 'on:line-item:change', 'cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, function () { scheduleReconcile(); });
  });
  document.addEventListener('shopify:section:load', function () { scheduleReconcile(); });

  // 3) On load (covers existing/returning carts, cart page, pre-rendered drawer).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { seedRefsFromDom(); reconcile(); });
  } else {
    seedRefsFromDom();
    reconcile();
  }

  // ---- Final safety net: standard checkout button ---------------------------
  // Protection is normally already present by now; reconcile() guarantees the
  // correct band before continuing (and honors the decline flag, so a shopper
  // who opted out is NOT re-added at the checkout button either). Retained for
  // any path the cart-event/AJAX signals missed.
  function continueCheckout(submitter) {
    var form = submitter && (submitter.form || submitter.closest('form'));
    if (form) {
      form.dataset.autoProtectionReady = 'true';
      if (typeof form.requestSubmit === 'function') { form.requestSubmit(submitter); return; }
      form.submit();
      return;
    }
    window.location.href = CHECKOUT_PATH;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var submitter = event.submitter;
    if (!(form instanceof HTMLFormElement)) return;
    if (!submitter || submitter.name !== 'checkout') return;
    if (form.dataset.autoProtectionReady === 'true') { delete form.dataset.autoProtectionReady; return; }
    event.preventDefault();
    reconcile().finally(function () { continueCheckout(submitter); });
  }, true);

  document.addEventListener('click', function (event) {
    var checkoutButton = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!checkoutButton) return;
    var form = checkoutButton.form || checkoutButton.closest('form');
    if (form && form.dataset.autoProtectionReady === 'true') return;
    event.preventDefault();
    reconcile().finally(function () { continueCheckout(checkoutButton); });
  }, true);

  // ---- Shared API (used by the visible toggle snippet; already live on Rare) -
  window.TBProtection = {
    handle: PROTECTION_PRODUCT_HANDLE,
    isOptedOut: isOptedOut,
    getMatchedVariant: function () {
      return Promise.all([getCart(), getProtectionProduct()]).then(function (res) {
        var v = selectProtectionVariant(res[1], protectableSubtotal(res[0]));
        return v ? { variant: v, price: v.price } : null;
      });
    },
    ensure: reconcile,
    reconcile: reconcile,
    remove: function () {
      return getCart()
        .then(function (c) { return removeProtection((c.items || []).filter(isProtectionItem)); })
        .then(function () { setTimeout(themeRefresh, 300); });
    },
    setOptedOut: function (optedOut) {
      persistOptOut(optedOut);
      return reconcile().then(function () {
        document.dispatchEvent(new CustomEvent('tb:protection:changed', { detail: { optedOut: optedOut } }));
      });
    }
  };
})();
